import { useEffect, useMemo, useState } from "react"

function StickyBottomBar() {
  const targetDate = useMemo(() => {
    const now = new Date()
    return new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000 + 14 * 60 * 60 * 1000 + 12 * 60 * 1000)
  }, [])

  const [timeLeft, setTimeLeft] = useState(() => calcTime(targetDate))

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calcTime(targetDate))
    }, 60000)
    return () => clearInterval(timer)
  }, [targetDate])

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-red-500 px-4 py-3 md:hidden shadow-[0_-4px_12px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-between gap-3">
        <div className="text-xs text-gray-600 font-medium">
          Oferta termina em{" "}
          <span className="font-bold text-red-600">
            {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m
          </span>
        </div>
        <a
          href="#cta-final"
          className="bg-blue-600 text-white text-sm font-bold px-4 py-2.5 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
        >
          Quero minha vaga &rarr;
        </a>
      </div>
    </div>
  )
}

function calcTime(target: Date) {
  const now = new Date()
  const diff = Math.max(0, target.getTime() - now.getTime())
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
  }
}

export default StickyBottomBar
